import PropTypes from 'prop-types';
import React from 'react';
import { TYPE_QUESTIONS } from '../constants';

import WrittenChart from '../charts-component/written-chart';

import {
  Container,
  ContainerChart,
  ContainerHeader,
  Header,
} from './styles';
import ImageQuestionChart from '../charts-component/image-chart';
import TaskChart from '../charts-component/task-chart';
import HeatmapChart from '../charts-component/heatmap-chart';
import MatrixChart from '../charts-component/matrix-chart';
import RankingChart from '../charts-component/ranking-chart';
import VerticalChart from '../../../../../core/analytics/vertical-chart-survey-and-unmoderated';

const SurveyPagesResults = (props) => {
  const { surveyPageResults, segmentSelected, projectTestType } = props;

  const {
    page,
    questions,
    projectId,
    testerIds = null,
  } = surveyPageResults;

  const handleChartComponent = (data) => {
    const {
      id,
      questionType,
    } = data;

    switch (questionType) {
      case TYPE_QUESTIONS.RANGE:
        return (
          <VerticalChart
            questionType={questionType}
            title="Rating Scale"
            color="#93dfff"
            data={data}
            key={id}
            projectTestType={projectTestType}
          />
        );

      case TYPE_QUESTIONS.WRITTEN:
        return (
          <WrittenChart
            title="Written Response"
            data={data}
            key={id}
            segmentId={segmentSelected}
            projectId={projectId}
            testerIds={testerIds}
          />
        );
      case TYPE_QUESTIONS.MULTIPLE_SELECT:
        return (
          <VerticalChart
            questionType={questionType}
            title="Multiple Selection"
            color="#A8BEF9"
            data={data}
            key={id}
            projectTestType={projectTestType}
            showOtherWritten
          />
        );

      case TYPE_QUESTIONS.SINGLE_SELECT:
        return (
          <VerticalChart
            questionType={questionType}
            title="Single Selection"
            color="#82EBD4"
            data={data}
            key={id}
            projectTestType={projectTestType}
            showOtherWritten
          />
        );
      case TYPE_QUESTIONS.IMAGE_SELECT:
        return (
          <ImageQuestionChart
            label={data}
            key={id}
          />
        );
      case TYPE_QUESTIONS.PREFERENCE:
        return (
          <VerticalChart
            questionType={questionType}
            title="Preference test"
            color="#9CDDFB"
            data={data}
            key={id}
            projectTestType={projectTestType}
            showImage
          />
        );
      case TYPE_QUESTIONS.TASK:
        return (
          <TaskChart
            title="Text"
            data={data}
            key={id}
          />
        );
      case TYPE_QUESTIONS.FIRST_CLICK:
        return (
          <HeatmapChart
            segmentId={segmentSelected}
            questionId={id}
            data={data}
            key={id}
          />
        );
      case TYPE_QUESTIONS.RANKING:
        return (
          <RankingChart
            title="Ranking"
            color="#9CDDFB"
            data={data}
            key={id}
          />
        );
      case TYPE_QUESTIONS.MATRIX:
        return (
          <MatrixChart
            title="Matrix"
            data={data}
            key={id}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Container>

      <ContainerHeader>
        <Header>{`Page ${page}`}</Header>
      </ContainerHeader>

      <ContainerChart>
        {surveyPageResults && questions.map((question) => (
          handleChartComponent(question)
        ))}
      </ContainerChart>

    </Container>
  );
};

SurveyPagesResults.defaultProps = {
  segmentSelected: '',
};

SurveyPagesResults.propTypes = {
  surveyPageResults: PropTypes.shape({
    questions: PropTypes.arrayOf(PropTypes.shape({})),
    projectId: PropTypes.string,
    page: PropTypes.number.isRequired,
    testerIds: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  segmentSelected: PropTypes.string,
  projectTestType: PropTypes.string.isRequired,
};

export default React.memo(SurveyPagesResults);
